import {
  NewsWidget,
  NewsWidgetFactory,
  WidgetMenuEntry,
  routeMatches,
} from '@/core/widgets/export';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PinnedSeriesWidget } from '@/modules/articles/export';

const urlPath = '/pinned-series/:genreQCode';

export class TabsCalendarWidgetFactory implements NewsWidgetFactory {
  get path(): string {
    return urlPath;
  }

  get headerPanel(): string | JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faCalendar} /> Calendars
      </>
    );
  }

  matchesTemplate(s: string): boolean {
    return !!routeMatches(this.path, s);
  }

  createInstance(s: string, customTitle?: string): NewsWidget {
    const match = routeMatches(this.path, s);

    if (match) return new PinnedSeriesWidget(match.genreQCode, false, customTitle);

    throw new Error('invalid url');
  }

  getListableUrls(): WidgetMenuEntry[] {
    return [
      {
        name: 'Economic Data Calendar',
        url: '/pinned-series/mni-section:480257874',
      },
      {
        name: 'Auction Calendars',
        children: [
          {
            name: 'Eurozone/UK Auction Bond Calendar',
            url: '/pinned-series/mni-section:480257876',
          },
          {
            name: 'Eurozone/UK Government T-Bill Auction Calendar',
            url: '/pinned-series/mni-section:480257877',
          },
          {
            name: 'US Treasury/Agency Auction Calendar',
            url: '/pinned-series/mni-section:480257875',
          },
        ],
      },
      {
        name: 'US$ Credit Supply Pipeline',
        url: '/pinned-series/mni-section:480257879',
      },
    ];
  }
}
